/**
 * @generated SignedSource<<94c7a5c7dd4a7b7c631e4bf9dd3c8e14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeactivatedQuotes_sku$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PreQuoteTitle_sku">;
  readonly " $fragmentType": "DeactivatedQuotes_sku";
};
export type DeactivatedQuotes_sku$key = {
  readonly " $data"?: DeactivatedQuotes_sku$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeactivatedQuotes_sku">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeactivatedQuotes_sku",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PreQuoteTitle_sku"
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "6b1dd1a1274d96d5959ed02f873c4324";

export default node;
